function fn_comp_boxes() {
    $comp = $(".comp_boxes");
    $comp.find(".image").parallax();
}